/* tslint:disable */
/* eslint-disable */
/**
 * Onbaording Buffetti Api
 * Onbaording Buffetti Api Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: gianluca.stefanelli@linksmt.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AllegatoDtoFromJSON, AllegatoDtoToJSON, } from './AllegatoDto';
import { FieldGroupDtoFromJSON, FieldGroupDtoToJSON, } from './FieldGroupDto';
import { FieldItemDtoFromJSON, FieldItemDtoToJSON, } from './FieldItemDto';
/**
 * @export
 */
export const ServizioDtoTipoServizioEnum = {
    Standard: 'STANDARD',
    Sd: 'SD',
    Conto: 'CONTO',
    Aci: 'ACI',
    PaymentFacilitator: 'PAYMENT_FACILITATOR',
    WebPos: 'WEB_POS',
    Adv: 'ADV'
};
/**
 * Check if a given object implements the ServizioDto interface.
 */
export function instanceOfServizioDto(value) {
    let isInstance = true;
    return isInstance;
}
export function ServizioDtoFromJSON(json) {
    return ServizioDtoFromJSONTyped(json, false);
}
export function ServizioDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'idServizio': !exists(json, 'idServizio') ? undefined : json['idServizio'],
        'idPratica': !exists(json, 'idPratica') ? undefined : json['idPratica'],
        'tipoServizio': !exists(json, 'tipoServizio') ? undefined : json['tipoServizio'],
        'numeroContiRichiesti': !exists(json, 'numeroContiRichiesti') ? undefined : FieldItemDtoFromJSON(json['numeroContiRichiesti']),
        'motivazioneAperturaConto': !exists(json, 'motivazioneAperturaConto') ? undefined : FieldGroupDtoFromJSON(json['motivazioneAperturaConto']),
        'convenzioniPos': !exists(json, 'convenzioniPos') ? undefined : FieldGroupDtoFromJSON(json['convenzioniPos']),
        'circuitoPagamentoPos': !exists(json, 'circuitoPagamentoPos') ? undefined : FieldGroupDtoFromJSON(json['circuitoPagamentoPos']),
        'servizioSpending': !exists(json, 'servizioSpending') ? undefined : FieldItemDtoFromJSON(json['servizioSpending']),
        'cartaVersamento': !exists(json, 'cartaVersamento') ? undefined : FieldGroupDtoFromJSON(json['cartaVersamento']),
        'servizioPos': !exists(json, 'servizioPos') ? undefined : FieldItemDtoFromJSON(json['servizioPos']),
        'isCartaVersamento': !exists(json, 'isCartaVersamento') ? undefined : FieldItemDtoFromJSON(json['isCartaVersamento']),
        'hasIntEstrattoContoUplaod': !exists(json, 'hasIntEstrattoContoUplaod') ? undefined : FieldItemDtoFromJSON(json['hasIntEstrattoContoUplaod']),
        'ibanAccredito': !exists(json, 'ibanAccredito') ? undefined : FieldItemDtoFromJSON(json['ibanAccredito']),
        'elencoAllegati': !exists(json, 'elencoAllegati') ? undefined : (json['elencoAllegati'].map(AllegatoDtoFromJSON)),
    };
}
export function ServizioDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'idServizio': value.idServizio,
        'idPratica': value.idPratica,
        'tipoServizio': value.tipoServizio,
        'numeroContiRichiesti': FieldItemDtoToJSON(value.numeroContiRichiesti),
        'motivazioneAperturaConto': FieldGroupDtoToJSON(value.motivazioneAperturaConto),
        'convenzioniPos': FieldGroupDtoToJSON(value.convenzioniPos),
        'circuitoPagamentoPos': FieldGroupDtoToJSON(value.circuitoPagamentoPos),
        'servizioSpending': FieldItemDtoToJSON(value.servizioSpending),
        'cartaVersamento': FieldGroupDtoToJSON(value.cartaVersamento),
        'servizioPos': FieldItemDtoToJSON(value.servizioPos),
        'isCartaVersamento': FieldItemDtoToJSON(value.isCartaVersamento),
        'hasIntEstrattoContoUplaod': FieldItemDtoToJSON(value.hasIntEstrattoContoUplaod),
        'ibanAccredito': FieldItemDtoToJSON(value.ibanAccredito),
        'elencoAllegati': value.elencoAllegati === undefined ? undefined : (value.elencoAllegati.map(AllegatoDtoToJSON)),
    };
}
